import React from 'react';
import { Box, TextField } from '@material-ui/core';
import { ArrowRightAltOutlined } from '@material-ui/icons';

/**
 * Interface pour les props du composant PricingIdsMapper
 */
interface Props {
  allPricing?: CRM.ActivityPrice[];
  value: CRM.PricingIdsMapping;
  onChange(value: CRM.PricingIdsMapping): void;
}

/**
 * Composant de mapping des identifiants de prix pour les intégrations externes
 * 
 * Ce composant permet de :
 * - Mapper les identifiants internes de prix vers les labels externes
 * - Associer chaque prix interne à un ou plusieurs labels externes
 * - Faciliter l'intégration avec des systèmes externes comme WooCommerce
 * 
 * Logique métier :
 * - Affichage de tous les prix disponibles avec leurs customId
 * - Interface de mapping bidirectionnel (interne ↔ externe)
 * - Sauvegarde automatique des mappings dans l'état parent
 * - Support des labels multiples séparés par virgules
 * 
 * @param allPricing Liste de tous les prix disponibles pour l'activité
 * @param value Mapping actuel des identifiants de prix
 * @param onChange Fonction appelée lors de la modification du mapping
 * @returns Composant React du mapper de prix
 */
export const PricingIdsMapper: React.FC<Props> = ({
  allPricing = [],
  onChange,
  value,
}) => {
  return (
    <Box display={'flex'} flexDirection={'column'} gridRowGap={10}>
      {allPricing.map(pricing => (
        <Box
          key={pricing.customId}
          display={'flex'}
          alignItems={'center'}
          gridGap={10}
        >
          <Box>{pricing.customId}</Box>
          <ArrowRightAltOutlined />
          <TextField
            label="Label(s) correspondant(s)"
            variant="outlined"
            value={value[pricing.customId] || ''}
            onChange={e =>
              onChange({ ...value, [pricing.customId]: e.target.value })
            }
          />
        </Box>
      ))}
    </Box>
  );
};
